import { render, staticRenderFns } from "./ProposalQueue.vue?vue&type=template&id=1d2542d0&scoped=true&"
import script from "./ProposalQueue.vue?vue&type=script&lang=js&"
export * from "./ProposalQueue.vue?vue&type=script&lang=js&"
import style0 from "./ProposalQueue.vue?vue&type=style&index=0&id=1d2542d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2542d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VTooltip})
